import { teamPageReducerTypes } from '../../../Reducer';

export const revokeAgent = (team, revokedAgent, teamPageDispatch) => {
  const agents = team.agents.filter(agent => agent.id !== revokedAgent.id);
  const newTeam = { ...team, agents: [...agents, revokedAgent] };
  teamPageDispatch({
    type: teamPageReducerTypes.updateTeamInfo,
    payload: newTeam,
  });
};

export const removeAgent = (team, removedAgent, teamPageDispatch) => {
  const agents = team.agents.filter(agent => agent.id !== removedAgent.id);
  const newTeam = { ...team, agents: [...agents] };
  teamPageDispatch({
    type: teamPageReducerTypes.updateTeamInfo,
    payload: newTeam,
  });
};

export const deleteTeam = teamPageDispatch => {
  teamPageDispatch({ type: teamPageReducerTypes.updateTeamInfo, payload: {} });
};
